module.exports = __webpack_public_path__ + "img/hair_front_female_frizzy_side_part_mask.8357cb96.png";